(() => {
  const occasions = {
    dessert: ['creamy-chocolate-martini', 'vanilla-caramel-cream-1'],
    brunch: ['mango-citrus-twist', 'peach-in-peace'],
    friends: ['watermelon-kissed', 'sangria-especial']
  };
  const initialize = () => {
    document.querySelectorAll('[data-w-discovery]').forEach(root => {
      if (root.dataset.discoveryReady) return;
      root.dataset.discoveryReady = 'true';
      const controls = root.querySelector('[data-w-filters]');
      if (!controls) return;
      controls.hidden = false;
      const params = new URLSearchParams(location.search);
      const state = {kind: ['creamy', 'fruity'].includes(params.get('kind')) ? params.get('kind') : 'all', format: params.get('format') === 'can' ? 'can' : 'all', occasion: occasions[params.get('occasion')] ? params.get('occasion') : null};
      const apply = () => {
        const items = [...root.querySelectorAll('[data-w-product]')];
        let visible = 0;
        items.forEach(item => {
          const show = (state.kind === 'all' || item.dataset.wKind === state.kind) && (state.format === 'all' || item.dataset.wCan === 'true') && (!state.occasion || occasions[state.occasion].includes(item.dataset.wHandle));
          item.hidden = !show;
          if (show) visible++;
        });
        controls.querySelectorAll('[data-w-filter]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.value === state[button.dataset.wFilter])));
        const results = root.querySelector('[data-w-results]');
        if (results) results.textContent = visible + ' ' + results.dataset.label;
        const empty = root.querySelector('[data-w-empty]');
        if (empty) empty.hidden = visible > 0;
        const track = root.querySelector('[data-product-track]');
        if (track) track.dispatchEvent(new CustomEvent('wondry:filter'));
        root.dispatchEvent(new CustomEvent('wondry:discovery', {bubbles: true, detail: {kind: state.kind, format: state.format, occasion: state.occasion, count: visible}}));
      };
      controls.addEventListener('click', event => {
        const button = event.target.closest('[data-w-filter]');
        if (!button) return;
        state[button.dataset.wFilter] = button.dataset.value;
        state.occasion = null;
        apply();
      });
      apply();
    });
    document.querySelectorAll('[data-serving-scene]').forEach(scene => {
      if (scene.dataset.sceneReady) return;
      scene.dataset.sceneReady = 'true';
      if ('IntersectionObserver' in window) {
        scene.setAttribute('data-offscreen', '');
        new IntersectionObserver(entries => scene.toggleAttribute('data-offscreen', !entries[0].isIntersecting), {threshold: 0.15}).observe(scene);
      }
      const visibility = () => scene.toggleAttribute('data-page-hidden', document.hidden);
      document.addEventListener('visibilitychange', visibility);
      visibility();
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize);
  else initialize();
  document.addEventListener('shopify:section:load', initialize);
})();





